export const content = `
  ol {
    text-align: left;
    line-height: 1.6;

    li + li {
      margin-top: 5px;
    }

    li ol {
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  
  li.unstyled {
    list-style: none;
  }

  ol + ol {
    margin-top: 20px;
  }

  h2 {
    margin-top: 1.8em;
  }
  
  p {
    color: black;
    text-align: left;
  }
`;
